import store from "@/store";
import MinistryRelationModule from "./store";
export default [
  {
    path: "/ministry-relation",
    component: () => import("./moduleLayout.vue"),
    beforeEnter(to, _, next) {
      if (!store.hasModule("MinistryRelation"))
        store.registerModule("MinistryRelation", MinistryRelationModule);
      next();
    },
    children: [
      {
        path: "incentives",
        name: "incentives",
        component: () => import("./pages/incentives/index.vue"),
        meta: {
          pageTitle: "الثناءات و العقوبات",
          slug: "ngo_incentives",
          breadcrumb: [
            {
              text: "العلاقة مع الوزارة",
              active: true,
            },
            {
              text: "الثناءات و العقوبات",
              active: true,
            },
          ],
        },
      },
      {
        path: "incentives/:id",
        name: "incentive-show",
        component: () => import("./pages/incentives/show.vue"),
        props: true,
        meta: {
          pageTitle: "الثناءات و العقوبات",
          slug: "ngo_incentives",
          breadcrumb: [
            {
              text: "العلاقة مع الوزارة",
              active: true,
            },
            {
              text: "الثناءات و العقوبات",
              to: "/ministry-relation/incentives",
            },
          ],
        },
      },
    ],
  },
];
